module.exports = __webpack_public_path__ + "static/img/cont37_04.25f0f15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37_04.jpg
// module id = hU5+
// module chunks = 0